import { marked } from 'marked';

export default (input) => marked.parse(input, { breaks: true, gfm: true });
